import { get } from '@/service/http';

const dictUrl = process.env.VUE_APP_DICT_URL;
const arr = ['option_avatar', 'nickname'];

const getAccountInfos = () => get(`${dictUrl}/login/acc/query/accountinfo`, { withCredentials: true });
const getBatchUrl = (params) => get(`${dictUrl}/profile/batch/get?content=${encodeURIComponent(JSON.stringify(arr))}`, params);

export default {
  getAccountInfos,
  getBatchUrl,
};
